<template>
  <div class="freeze" :style="(currentIndex != 0 && !$isFlag) ? 'background:#fff' : ''">
    <header-item
      :title-array="titleArray"
      :is-show="true"
      :title-mb="titleArray[0]"
      type-next="click"
      @navBarClick="navBarClick"
    />
    <div class="lt-freeze-form" @submit="handleSubmit">
      <van-form class="appealInfo">
        <!-- 请选择操作系统 -->
        <van-field
          name="sys"
          style="border-radius: 16px 16px 0 0;"
          label="操作系统："
          :rules="[{ required: true, message: '请选择操作系统' }]"
          class="radio"
          required
        >
          <template #input>
            <van-radio-group v-model="freezeParams.sys" direction="horizontal">
              <van-radio name="110001">安卓官方</van-radio>
              <van-radio name="210009">雷霆iOS</van-radio>
              <van-radio name="150001">鸿蒙官方</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!-- 请选择游戏 -->
        <van-field
          name="gameCode"
          label="选择游戏："
          class="lt-freeze-select"
          required
          :rules="[{ required: true, message: '' }]"
        >
          <template #input>
            <common-select :selection-info="{selectName:'',columns:gameList,label:'gameName',val:'gameCode'}" @emitParentVal="emitGameCode" />
          </template>
        </van-field>
        <!-- 请选择区组 -->
        <van-field
          name="zoneId"
          label="游戏区组："
          class="lt-freeze-select"
          required
          :rules="[{ required: true, message: '' }]"
        >
          <template #input>
            <common-select ref="zoneSelect" :selection-info="{selectName:'',columns:zoneList,label:'zoneName',val:'zoneId'}" @emitParentVal="emitZoneId" />
          </template>
        </van-field>
        <!-- 雷霆账号 -->
        <van-field
          v-model="freezeParams.account"
          label="雷霆账号："
          required
          :rules="[{ required: true, message: '不可为空' }]"
        />
        <!-- 真实姓名 -->
        <van-field
          v-model="freezeParams.name"
          label="您的姓名（账号注册时填写的姓名）："
          required
          class="van-field__label_wrap"
          :rules="[{ required: true, message: '不可为空' }]"
          placeholder="账号注册时填写的姓名"
        />
        <!-- 身份证号码 -->
        <van-field
          v-model="freezeParams.idCard"
          label="身份证号码（账号注册时填写的身份证号码）："
          class="van-field__label_wrap"
          required
          name="idCard"
          :rules="rules.idRules"
          placeholder="账号注册时填写的身份证号码"
        />
        <!-- 曾用手机号 -->
        <van-field
          v-model="freezeParams.phone"
          label="曾用手机号（7天内账号曾经使用过的绑定手机号）："
          class="van-field__label_wrap"
          required
          :rules="rules.mobileRules"
          placeholder="7天内账号曾经使用过的绑定手机号"
        />
        <!-- 短信验证码 -->
        <van-field
          v-model="freezeParams.phoneCode"
          label="短信验证码："
          maxlength="6"
          required
          style="border-radius: 0 0 16px 16px;"
          :rules="rules.codeRules"
          placeholder="请输入验证码"
        >
          <template #button>
            <p v-if="!showTime" style="color: #616edf; cursor: pointer" @click="getCode">{{ timeMsg }}</p>
            <p v-else style="color: #878787; cursor: pointer">{{ codeTime }} S</p>
          </template>
        </van-field>
        <p class="reg_p" style="">*如果一分钟内没有收到验证码请重新获取</p>
        <!-- button -->
        <div class="bottom">
          <van-button
            round
            block
            type="info"
            color="#616edf"
            class="formClass_btn"
            @click="handleSubmit"
          >申请冻结</van-button>
        </div>
      </van-form>
    </div>
    <!-- 查询说明 -->
    <div class="lt-freeze-description">
      <h4>查询说明：</h4>
      <p>1、本页面功能仅限官方iOS、官方安卓、官方鸿蒙区组，渠道区组暂不支持查询</p>
      <p>2、申请保护性冻结账号必须是已完善账号有效证件号码且账号的绑定手机7天内存在更改情况</p>
      <!-- <p>3、曾用手机号为7天内曾经使用过的绑定手机号（不包含当前绑定手机号，若是当前绑定手机号仍可使用，<a href="https://id.leiting.com/accountCenter/accountSelf/findPassWord">点击这里</a>修改密码即可）</p> -->
      <p>3、曾用手机号为7天内曾经使用过的绑定手机号（不包含通过申诉重置的绑定手机号和当前绑定手机号，若是当前绑定手机号仍可使用，<a href="https://id.leiting.com/accountCenter/accountSelf/findPassWord">点击这里</a>修改密码即可）</p>
      <p>4、账号30天内只能申请一次保护性冻结，请妥善保管账号信息</p>
      <p>5、已被封停账号无法进行申请保护性冻结</p>
      <p>6、账号保护性冻结时长为永久，冻结后需要通过账号申诉后，重置并绑定手机号码方可申请解冻，申诉失败或未审核前无法解冻，
        <a href="https://lt0.site/ezD4O0">点击这里</a>账号申诉
      </p>
    </div>
  </div>
</template>

<script>
import rules from '@/mixins/validator'
import sendCode from '@/mixins/sendCode'
import { ltCaptcha } from '@/utils/ltCaptcha'
import { throttle } from '@/utils/debounce.js'
import commonSelect from '@/components/commonSelect'
import headerItem from '@/views/accountCenter/common/header'
import * as api from '@/api/account-self-manage/accountFreeze'
import { send_phone_code } from '@/api/account-self-manage/accountAppeal'

export default {
  name: 'AccountProtectFreeze',
  components: {
    headerItem,
    commonSelect
  },
  mixins: [sendCode],
  data() {
    return {
      backFlag: true,
      rules: rules,
      gameList: [],
      zoneList: [],
      currentIndex: 0,
      titleArray: ['账号保护性冻结', '首页', '账号自助管理', '账号保护性冻结'],
      freezeParams: {}
    }
  },
  mounted() {
    if (this.$isFlag) {
      document.querySelector('.freeze').className = ['freeze accountFreezeH5 accountCommonH5']
    } else {
      document.querySelector('.freeze').className = ['freeze accountFreezeWeb accountCommonWeb']
    }
    api.game_list().then(res => {
      if (res.status == 0) {
        this.gameList = res.data ? res.data : []
      }
    })
  },
  methods: {
    getZoneList(gameCode) {
      this.$loading.show()
      api.zone_list({
        gameCode,
        searchType: 1 // 1 代表查询所有区组 2代表查询官方区组 3代表渠道区组
      }).then((res) => {
        this.$loading.hide()
        if (res.status !== 0) return
        this.zoneList = res.data ? res.data : []
      }, () => {
        this.$loading.hide()
      })
    },
    navBarClick() {
      if (this.currentIndex == 1) {
        this.currentIndex = 0
      } else {
        this.$router.go(-1)
      }
    },
    emitGameCode(label, val) {
      this.freezeParams.gameCode = val
      this.freezeParams.gameName = label
      this.zoneList = []
      // 切换游戏时清空区组列表
      this.emitZoneId('', '')
      if (this.$isFlag) {
        this.$refs.zoneSelect.onConfirm('')
      } else {
        this.$refs.zoneSelect.gameVal = ''
        this.$refs.zoneSelect.selectionInfo.selectName = ''
      }
      if (val) {
        this.getZoneList(val)
      }
    },
    emitZoneId(label, val) {
      this.freezeParams.zoneId = val
      this.freezeParams.zoneName = label
    },
    handleSubmit: throttle(function() {
      this.$ssd.track('leiting_freeze')
      this.$loading.show()
      api.freeze_apply(this.freezeParams).then((res) => {
        this.$loading.hide()
        if (res.status === 0) {
          this.$msg('您已经成功完成账号保护性冻结。', 'success')
        }
      }, () => {
        this.$loading.hide()
      })
    }, 300),
    getCode() {
      if (!this.freezeParams.phone) {
        this.$msg('请输入手机号')
        return
      }
      ltCaptcha((captcha) => {
        send_phone_code({
          type: 'SELF_ACCOUNT_FREEZE',
          phoneNum: this.freezeParams.phone,
          captcha
        }).then(res => {
          if (res.status == 0) {
            this.$msg('短信发送成功', 'success')
            this.startTimer()
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';
@import '~assets/css/accountCenter/accountFreeze.styl';
.accountCommonWeb {
  ::v-deep .van-field__label {
    width: 92%;
  }
}
</style>
